import {
  alerter,
} from '@codev/helix-react';
import React from 'react';
import PropTypes from 'prop-types';
import Frame from '../Frame.jsx';
import window from '../globalWrappers/window.js';
import Panel from '../Panel.jsx';
import PanelDivider from '../PanelDivider.jsx';
import api from './api.js';
import BadTokenMessage from './BadTokenMessage.jsx';
import createLoginLink from './createLoginLink.js';
import NewPasswordForm from './NewPasswordForm.jsx';

class ResetPasswordView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      password: '',
    };
  }

  handleResetPassword = async () => {
    let {
      antiforgeryConfig,
      isNewAdmin,
      token,
    } = this.props;
    let {
      password,
    } = this.state;

    alerter.dismiss();

    try {
      await api.completeForgotPassword({
        requestVerificationToken: antiforgeryConfig.value,
        password,
        token: token,
      });
    } catch(exception) {
      alerter.alert({
        type: 'error',
        message: (exception.body && exception.body.message) || 'We were unable to reset your password. Please try again.',
      });

      return;
    }

    window.location = createLoginLink(`We've ${isNewAdmin ? 'set' : 'reset'} the password on your admin account. Please log in below.`);

  }

  render() {
    let {
      isNewAdmin,
      isTokenValid,
      logoUrl,
    } = this.props;
    let {
      password,
    } = this.state;

    if (!isTokenValid) {
      return (
        <Frame
          title="Reset Password"
        >
          {
            logoUrl &&
            <Panel>
              <img id="logo" src={logoUrl} />
            </Panel>
          }
          {
            logoUrl &&
            <PanelDivider />
          }
          <BadTokenMessage />
        </Frame>
      );
    }

    return (
      <Frame
        title={isNewAdmin ? 'Set Password' : 'Reset Password'}
      >
        <NewPasswordForm
          isFirstTimeAdmin={isNewAdmin}
          onChange={x => this.setState({password: x})}
          onSubmit={this.handleResetPassword}
          value={password}
        />
      </Frame>
    );
  }
}

ResetPasswordView.propTypes = {
  antiforgeryConfig: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }),
  isNewAdmin: PropTypes.bool,
  isTokenValid: PropTypes.bool,
  token: PropTypes.string,
  logoUrl: PropTypes.string,
};

export default ResetPasswordView;
